<p>Just for testing...</p>
<button mat-stroked-button color="accent" (click)="mint()">
  Get 5 dark ritual coupons
</button>
<br><br>
